import { Country, Currency } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { IMAGE_PERSPECTIVE } from "./config";

type Breakpoint = "S" | "M" | "L";

type WidthAndHeight = { width: number; height: number };

type Screen = {
  [point in Breakpoint]: boolean;
} & WidthAndHeight;

type I18nKey = string;

type UUID = string;

type Locale =
  | "fr-BE"
  | "de-DE"
  | "es-ES"
  | "fr-FR"
  | "en-GB"
  | "it-IT"
  | "fr-LU"
  | "pt-PT"
  | "de-AT"
  | "nl-NL"
  | "sv-SE"
  | "de-CH"
  | "fr-CH";

type Device = "web" | "app";

enum Container {
  CONTAINER_1 = "container1",
  CONTAINER_2 = "container2",
  CONTAINER_3 = "container3",
  CONTAINER_4 = "container4",
  CONTAINER_5 = "container5",
}

type PerspectiveKey = keyof typeof IMAGE_PERSPECTIVE;
type Perspective = (typeof IMAGE_PERSPECTIVE)[PerspectiveKey];

type Media = {
  url: string;
  perspective: Perspective;
};

type Size = {
  name: string;
  sizeVariants: [];
  variantId: UUID;
};

type UpdateOrderItemsPayload = {
  itemId: string;
  orderId: string;
  variantId?: string;
  serviceId: string;
};

type UpdateOrderItemsPayloadWithAuth = UpdateOrderItemsPayload & { auth: string; apiUrl: () => string };

type User = {
  readonly country: Country;
  readonly id: string;
  readonly email: string;
  readonly segment: Segment;
  readonly shippingAddress: {
    readonly address: {
      readonly address: string;
      readonly postCode: string;
      readonly city: string;
      readonly name: string;
    };
  };
};

type Session = {
  readonly auth: string;
  readonly user: User;
};

type Store = {
  readonly set: (key: string, obj: unknown) => Promise<void>;
  readonly get: (key: string) => Promise<unknown | undefined>;
  readonly has: (key: string) => Promise<boolean>;
  readonly remove: (key: string) => Promise<void>;
};

type OrderStatus =
  | "SELECTION_DONE"
  | "WAREHOUSE_ERROR"
  | "SENT"
  | "DELIVERY_NOTIFIED"
  | "CLOSED"
  | "DISCARDED"
  | "CANCELLED";

type RequireAtLeastOne<T> = { [K in keyof T]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<keyof T, K>>> }[keyof T];

enum Offering {
  COMPLETE_YOUR_LOOK = "COMPLETE_YOUR_LOOK",
  CATEGORIES = "CATEGORIES",
  SALES = "SALES",
  TRENDING_FOR_YOU = "TRENDING_FOR_YOU",
}

export type {
  Breakpoint,
  Device,
  I18nKey,
  Locale,
  Media,
  OrderStatus,
  PerspectiveKey,
  RequireAtLeastOne,
  Screen,
  Session,
  Size,
  Store,
  UpdateOrderItemsPayload,
  UpdateOrderItemsPayloadWithAuth,
  User,
  UUID,
  WidthAndHeight,
};
export { Container, Currency, Offering };
